/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeliveryHandoffInstructions {
    HANDITTOME = 'HAND_IT_TO_ME',
    LEAVEITATMYDOOR = 'LEAVE_IT_AT_MY_DOOR',
    OTHER = 'OTHER'
}

export function DeliveryHandoffInstructionsFromJSON(json: any): DeliveryHandoffInstructions {
    return DeliveryHandoffInstructionsFromJSONTyped(json, false);
}

export function DeliveryHandoffInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryHandoffInstructions {
    return json as DeliveryHandoffInstructions;
}

export function DeliveryHandoffInstructionsToJSON(value?: DeliveryHandoffInstructions | null): any {
    return value as any;
}

